import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Titles = styled.div`
  border-bottom: 1px solid #84b1cc;
  display: flex;
  margin-left: -16px;
  width: 100vw;
  min-height: 53px;
  position: relative;
  @media (min-width: 640px) {
    margin-left: 0px;
    width: 100%;
  }
`;

const Button = styled.button`
  &.tabs {
    padding: 16px;
    text-align: center;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #4f6168;
    cursor: pointer;
    box-sizing: content-box;
    position: relative;
    outline: none;
    width: max-content;
  }
  &.tabs:hover {
    background: #e2dffd;
    color: #5b36f2;
  }
  &.tabs:focus {
    background: #c6c0fc;
    color: #5b36f2;
  }
  &.tabs:active {
    background: #c6c0fc;
    color: #5b36f2;
  }
  &.active-tabs {
    color: #5b36f2 !important;
  }
  &.active-tabs::before {
    content: '';
    display: block;
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 30px);
    height: 5px;
    background: #5b36f2;
    border-radius: 3px;
  }
`;

const ContentWrapper = styled.div`
  flex-grow: 1;
`;

const Content = styled.div`
  &.content {
    width: 100%;
    height: 100%;
    display: none;
  }
  &.active-content {
    display: block;
  }
`;

export { Container, Titles, Button, ContentWrapper, Content };
